var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Pane, Button, Row, Col, Checkbox, MessageBanner, Loading, PaneFooter, RadioButton, ErrorModal, AccordionSet, Accordion, Layout, List, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekTextField } from "../../components/inputs";
import { fetchUserById, updateUser, updateUserLibrary, } from "../../api/userService";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { useModal } from "../../utils/useModal";
import { ExpandCollapseToggle } from "../../components/ExpandCollapseToggle";
var UserEdit = function () {
    var _a, _b, _c;
    var userId = useParams().id;
    var history = useHistory();
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var _d = useModal(), isErrorModalOpen = _d.isOpen, errorModalMessage = _d.message, showErrorModal = _d.openModal, hideErrorModal = _d.closeModal;
    var _e = useState("ACTIVE"), userStatus = _e[0], setUserStatus = _e[1];
    var _f = useState(false), isAdmin = _f[0], setIsAdmin = _f[1];
    var _g = useState({}), libraryPermissions = _g[0], setLibraryPermissions = _g[1];
    var _h = useState(false), isSaving = _h[0], setIsSaving = _h[1];
    var _j = useState({
        basicInfo: true,
        libraries: true,
        status: true,
    }), accordionStatus = _j[0], setAccordionStatus = _j[1];
    var _k = useState(true), expandAll = _k[0], setExpandAll = _k[1];
    var toggleAccordion = function (section) {
        setAccordionStatus(function (previousStatus) {
            var _a;
            return (__assign(__assign({}, previousStatus), (_a = {}, _a[section] = !previousStatus[section], _a)));
        });
    };
    var toggleExpandCollapseAll = function () {
        setAccordionStatus({
            basicInfo: !expandAll,
            libraries: !expandAll,
            status: !expandAll,
        });
        setExpandAll(!expandAll);
    };
    var _l = useQuery(["user", userId], function () { return fetchUserById(kyInstance, userId); }, {
        enabled: !!userId,
    }), user = _l.data, isUserLoading = _l.isLoading, isUserError = _l.isError;
    useEffect(function () {
        var _a, _b, _c, _d;
        if (user) {
            setUserStatus((_a = user.status) !== null && _a !== void 0 ? _a : "ACTIVE");
            var userHasAdminRole = (_c = (_b = user.libraries) === null || _b === void 0 ? void 0 : _b.some(function (userLibrary) { return userLibrary.isAdmin; })) !== null && _c !== void 0 ? _c : false;
            setIsAdmin(userHasAdminRole);
            var initialPermissions_1 = {};
            (_d = user.libraries) === null || _d === void 0 ? void 0 : _d.forEach(function (userLibrary) {
                var _a, _b, _c, _d, _e;
                if ((_a = userLibrary.library) === null || _a === void 0 ? void 0 : _a.id) {
                    initialPermissions_1[userLibrary.library.id] = {
                        monographs: (_c = (_b = userLibrary.permissions) === null || _b === void 0 ? void 0 : _b.monographs) !== null && _c !== void 0 ? _c : false,
                        periodicals: (_e = (_d = userLibrary.permissions) === null || _d === void 0 ? void 0 : _d.periodicals) !== null && _e !== void 0 ? _e : false,
                    };
                }
            });
            setLibraryPermissions(initialPermissions_1);
        }
    }, [user]);
    var updateUserStatusMutation = useMutation(function (status) { return updateUser(kyInstance, userId, { status: status }); }, {
        onError: function () {
            showErrorModal(formatMessage({ id: "ui-br-legaldeposits.users.edit.error.update" }));
        },
    });
    var updateUserLibraryMutation = useMutation(function (_a) {
        var libraryId = _a.libraryId, payload = _a.payload;
        return updateUserLibrary(kyInstance, userId, libraryId, payload);
    }, {
        onError: function () {
            showErrorModal(formatMessage({ id: "ui-br-legaldeposits.users.edit.error.update" }));
        },
    });
    var handleLibraryPermissionChange = function (libraryId, permissionField, isEnabled) {
        setLibraryPermissions(function (previousPermissions) {
            var _a, _b;
            return (__assign(__assign({}, previousPermissions), (_a = {}, _a[libraryId] = __assign(__assign({}, previousPermissions[libraryId]), (_b = {}, _b[permissionField] = isEnabled, _b)), _a)));
        });
    };
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _i, _a, userLibrary, currentPermissions, updatedPermissions, updatedIsAdmin, updatedMonographs, updatedPeriodicals, hasPermissionsChanged, _b;
        var _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    if (!user)
                        return [2 /*return*/];
                    setIsSaving(true);
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 8, 9, 10]);
                    if (!(userStatus !== user.status)) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateUserStatusMutation.mutateAsync(userStatus)];
                case 2:
                    _l.sent();
                    _l.label = 3;
                case 3:
                    _i = 0, _a = (_c = user.libraries) !== null && _c !== void 0 ? _c : [];
                    _l.label = 4;
                case 4:
                    if (!(_i < _a.length)) return [3 /*break*/, 7];
                    userLibrary = _a[_i];
                    if (!((_d = userLibrary.library) === null || _d === void 0 ? void 0 : _d.id)) return [3 /*break*/, 6];
                    currentPermissions = {
                        isAdmin: userLibrary.isAdmin,
                        monographs: (_f = (_e = userLibrary.permissions) === null || _e === void 0 ? void 0 : _e.monographs) !== null && _f !== void 0 ? _f : false,
                        periodicals: (_h = (_g = userLibrary.permissions) === null || _g === void 0 ? void 0 : _g.periodicals) !== null && _h !== void 0 ? _h : false,
                    };
                    updatedPermissions = libraryPermissions[userLibrary.library.id];
                    updatedIsAdmin = isAdmin;
                    updatedMonographs = isAdmin
                        ? false
                        : ((_j = updatedPermissions === null || updatedPermissions === void 0 ? void 0 : updatedPermissions.monographs) !== null && _j !== void 0 ? _j : false);
                    updatedPeriodicals = isAdmin
                        ? false
                        : ((_k = updatedPermissions === null || updatedPermissions === void 0 ? void 0 : updatedPermissions.periodicals) !== null && _k !== void 0 ? _k : false);
                    hasPermissionsChanged = currentPermissions.isAdmin !== updatedIsAdmin ||
                        currentPermissions.monographs !== updatedMonographs ||
                        currentPermissions.periodicals !== updatedPeriodicals;
                    if (!hasPermissionsChanged) return [3 /*break*/, 6];
                    return [4 /*yield*/, updateUserLibraryMutation.mutateAsync({
                            libraryId: userLibrary.library.id,
                            payload: {
                                isAdmin: updatedIsAdmin,
                                permissions: {
                                    monographs: updatedMonographs,
                                    periodicals: updatedPeriodicals,
                                },
                            },
                        })];
                case 5:
                    _l.sent();
                    _l.label = 6;
                case 6:
                    _i++;
                    return [3 /*break*/, 4];
                case 7:
                    queryClient.invalidateQueries(["user", userId]);
                    queryClient.invalidateQueries("users");
                    history.goBack();
                    return [3 /*break*/, 10];
                case 8:
                    _b = _l.sent();
                    showErrorModal(formatMessage({ id: "ui-br-legaldeposits.users.edit.error.update" }));
                    return [3 /*break*/, 10];
                case 9:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 10: return [2 /*return*/];
            }
        });
    }); };
    var handleCancel = function () {
        history.goBack();
    };
    if (isUserLoading) {
        return React.createElement(Loading, null);
    }
    if (isUserError || !user) {
        return (React.createElement(Pane, { paneTitle: formatMessage({
                id: "ui-br-legaldeposits.users.edit.title",
            }), defaultWidth: "fill" },
            React.createElement(MessageBanner, { type: "error" },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.error.user.not.found" }))));
    }
    var userFullName = "".concat(user.firstName || "", " ").concat(user.lastName || "").trim();
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "editPane", paneTitle: formatMessage({ id: "ui-br-legaldeposits.users.edit.title.name" }, { name: userFullName }), defaultWidth: "fill", onClose: handleCancel, dismissible: true, footer: React.createElement(PaneFooter, { renderStart: React.createElement(Button, { type: "submit", buttonStyle: "primary", marginBottom0: true, onClick: handleSubmit, disabled: isSaving },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.users.edit.button.save" })), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: handleCancel, marginBottom0: true },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.users.edit.button.cancel" })) }) },
            React.createElement(ErrorModal, { open: isErrorModalOpen, label: formatMessage({ id: "ui-br-legaldeposits.modal.error.label" }), content: errorModalMessage, onClose: hideErrorModal }),
            React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
            React.createElement(AccordionSet, null,
                React.createElement(Accordion, { label: formatMessage({
                        id: "ui-br-legaldeposits.users.edit.section.basicInfo",
                    }), open: accordionStatus.basicInfo, onToggle: function () { return toggleAccordion("basicInfo"); }, separator: false },
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 6 },
                            React.createElement(MessageBanner, { type: "warning" },
                                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.users.edit.basicInfo.warning" })))),
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 6 },
                            React.createElement(RecekTextField, { labelId: "ui-br-legaldeposits.users.field.name", value: userFullName, disabled: true }))),
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 6 },
                            React.createElement(RecekTextField, { labelId: "ui-br-legaldeposits.users.field.email", value: user.email || "", disabled: true })))),
                React.createElement(Accordion, { label: formatMessage({
                        id: "ui-br-legaldeposits.users.accordion.libraries",
                    }), open: accordionStatus.libraries, onToggle: function () { return toggleAccordion("libraries"); }, separator: false }, ((_b = (_a = user.libraries) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) === 0 ? (React.createElement(MessageBanner, { type: "warning" },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.users.detail.noLibraries" }))) : (React.createElement(React.Fragment, null,
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 12 },
                            React.createElement(MessageBanner, { type: "warning" },
                                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.users.edit.libraries.info" })))),
                    React.createElement(Layout, { className: "marginTop1" },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Checkbox, { label: formatMessage({
                                        id: "ui-br-legaldeposits.users.edit.role.admin",
                                    }), checked: isAdmin, onChange: function (event) {
                                        setIsAdmin(event.target.checked);
                                    } })))),
                    isAdmin ? (React.createElement(Layout, { className: "marginTop1" },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(MessageBanner, { type: "warning" },
                                    React.createElement("strong", null,
                                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.users.edit.admin.banner.title" })),
                                    React.createElement(List, { items: [
                                            formatMessage({
                                                id: "ui-br-legaldeposits.users.edit.admin.banner.point1",
                                            }),
                                            formatMessage({
                                                id: "ui-br-legaldeposits.users.edit.admin.banner.point2",
                                            }),
                                            formatMessage({
                                                id: "ui-br-legaldeposits.users.edit.admin.banner.point3",
                                            }),
                                        ], itemFormatter: function (item) { return (React.createElement("li", { key: item }, item)); }, listStyle: "bullets", marginBottom0: true })))))) : (React.createElement(React.Fragment, null, (_c = user.libraries) === null || _c === void 0 ? void 0 : _c.map(function (userLibrary) {
                        var _a, _b, _c, _d, _e, _f, _g;
                        return (React.createElement("div", { key: userLibrary.id, style: {
                                marginTop: "1rem",
                                paddingBottom: "1rem",
                                borderBottom: "1px solid #e0e0e0",
                            } },
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement("strong", null, (_a = userLibrary.library) === null || _a === void 0 ? void 0 : _a.name))),
                            React.createElement(Layout, { className: "marginTop1" },
                                React.createElement(Row, null,
                                    React.createElement(Col, { xs: 12 },
                                        React.createElement(Checkbox, { label: formatMessage({
                                                id: "ui-br-legaldeposits.users.edit.permission.monographs",
                                            }), checked: ((_b = userLibrary.library) === null || _b === void 0 ? void 0 : _b.id)
                                                ? ((_d = (_c = libraryPermissions[userLibrary.library.id]) === null || _c === void 0 ? void 0 : _c.monographs) !== null && _d !== void 0 ? _d : false)
                                                : false, onChange: function (event) {
                                                var _a;
                                                if ((_a = userLibrary.library) === null || _a === void 0 ? void 0 : _a.id) {
                                                    handleLibraryPermissionChange(userLibrary.library.id, "monographs", event.target.checked);
                                                }
                                            } }))),
                                React.createElement(Row, null,
                                    React.createElement(Col, { xs: 12 },
                                        React.createElement(Checkbox, { label: formatMessage({
                                                id: "ui-br-legaldeposits.users.edit.permission.periodicals",
                                            }), checked: ((_e = userLibrary.library) === null || _e === void 0 ? void 0 : _e.id)
                                                ? ((_g = (_f = libraryPermissions[userLibrary.library.id]) === null || _f === void 0 ? void 0 : _f.periodicals) !== null && _g !== void 0 ? _g : false)
                                                : false, onChange: function (event) {
                                                var _a;
                                                if ((_a = userLibrary.library) === null || _a === void 0 ? void 0 : _a.id) {
                                                    handleLibraryPermissionChange(userLibrary.library.id, "periodicals", event.target.checked);
                                                }
                                            } }))))));
                    })))))),
                React.createElement(Accordion, { label: formatMessage({
                        id: "ui-br-legaldeposits.users.edit.field.status",
                    }), open: accordionStatus.status, onToggle: function () { return toggleAccordion("status"); }, separator: false },
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 6 },
                            React.createElement(RadioButton, { label: formatMessage({
                                    id: "ui-br-legaldeposits.userStatus.active",
                                }), checked: userStatus === "ACTIVE", onChange: function () { return setUserStatus("ACTIVE"); } }),
                            React.createElement(RadioButton, { label: formatMessage({
                                    id: "ui-br-legaldeposits.userStatus.inactive",
                                }), checked: userStatus === "INACTIVE", onChange: function () { return setUserStatus("INACTIVE"); } }))))))));
};
export default UserEdit;
